import { AxiosResponse } from 'axios';
import { GracePeriodUpdateRequest } from '../types/gracePeriod';
import { GracePeriodResponse } from '../types/policy';
import { getApiUrl } from '../util/util';
import { get, patch } from './http';

interface GracePeriodApi {
	updateGracePeriod(
		authorizationToken: string,
		params: GracePeriodUpdateRequest,
		locator: string,
	): Promise<AxiosResponse<GracePeriodResponse>>;
	getGracePeriods(
		authorizationToken: string,
		policyLocator: string,
	): Promise<AxiosResponse<GracePeriodResponse[]>>;
}

export default {
	updateGracePeriod(
		authorizationToken: string,
		params: GracePeriodUpdateRequest,
		locator: string,
	) {
		return patch(
			encodeURI(`${getApiUrl()}/gracePeriod/${locator}`),
			authorizationToken,
			params,
		);
	},
	getGracePeriods(authorizationToken: string, policyLocator: string) {
		return get(
			`${getApiUrl()}/policy/${policyLocator}/gracePeriods`,
			authorizationToken,
		);
	},
} as GracePeriodApi;
